import {
  Emoji,
  CLIENT_VIEWS,
  ALERT_VIEWS,
  PATCH_VIEWS,
  MAILBOX_VIEWS,
  BackgroundIcon
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { SVGIcon } from '@superops/super-icons';
import React, { useCallback, useContext } from 'react';

const unknown = (el) => {
  switch (el.id) {
    case 'mail-view':
    case MAILBOX_VIEWS.unknownEmails:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="📮" label="my_mails" />
        </div>
      );

    case CLIENT_VIEWS.activeClients:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="❤️" label="activeClients" />
        </div>
      );
    case CLIENT_VIEWS.allClients:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🏛️" label="allClients" />
        </div>
      );
    case CLIENT_VIEWS.myClients:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🏢" label="myClients" />
        </div>
      );
    case CLIENT_VIEWS.prospects:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="💰" label="prospects" />
        </div>
      );
    case CLIENT_VIEWS.trash:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🗑️" label="trash" />
        </div>
      );
    case CLIENT_VIEWS.contracts:
    case '15':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="📝" label="contracts" />
        </div>
      );
    case CLIENT_VIEWS.invoiceAudit:
    case '17':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="‼️" label="invoiceAudit" />
        </div>
      );
    case CLIENT_VIEWS.approvedItems:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="✅" label="approvedItems" />
        </div>
      );
    case CLIENT_VIEWS.ignoredItems:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🚫" label="ignoredItems" />
        </div>
      );
    case CLIENT_VIEWS.allInvoices:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="💵" label="allInvoices" />
        </div>
      );
    case CLIENT_VIEWS.pendingInvoices:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="⁉️" label="pendingInvoices" />
        </div>
      );
    case CLIENT_VIEWS.invoiceSettings:
    case CLIENT_VIEWS.paymentSettings:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="⚙️" label="invoiceSettings" />
        </div>
      );

    case MAILBOX_VIEWS.newConversations:
    case MAILBOX_VIEWS.clientNewConversations:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="📨" label="newConversations" />
        </div>
      );
    case MAILBOX_VIEWS.clientCommunications:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🏛️" label="clientCommunications" />
        </div>
      );
    case MAILBOX_VIEWS.prospectCommunications:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="💰" label="prospectCommunications" />
        </div>
      );
    case MAILBOX_VIEWS.allConversations:
    case MAILBOX_VIEWS.clientAllConversations:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="📬" label="allConversations" />
        </div>
      );
    case MAILBOX_VIEWS.sentEmails:
    case MAILBOX_VIEWS.clienSentEmails:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🚀" label="sentEmails" />
        </div>
      );
    case 'requester-view':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🤵" label="requesters" />
        </div>
      );
    default:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🎟️" label="default_ticket" />
        </div>
      );
  }
};

const getTicketEmoji = (el) => {
  switch (el.id) {
    case '2':
    case '16':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🎩" label="my_tickets" />
        </div>
      );
    case '9':
    case '19':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🗑️" label="delete" />
        </div>
      );
    case '8':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="⚠️" label="spam" />
        </div>
      );
    case '18':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="❓" label="unknown_ticket" />
        </div>
      );
    case '10':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="⏱" label="due_today" />
        </div>
      );

    case '11':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="📂" label="group_tickets" />
        </div>
      );
    case '12':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="👣" label="follow" />
        </div>
      );
    case '13':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="👤" label="unassigned" />
        </div>
      );
    case CLIENT_VIEWS.contracts:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="📝" label="contracts" />
        </div>
      );
    default:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🎟️" label="default_ticket" />
        </div>
      );
  }
};

const getTaskEmoji = (el) => {
  switch (el.id) {
    case '4':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🧢" label="my_tasks" />
        </div>
      );
    case '3':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🗃️" label="all_tasks" />
        </div>
      );
    case '14':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🧰" label="group_tasks" />
        </div>
      );
    default:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="🗃️" label="all_tasks" />
        </div>
      );
  }
};

const getProjectEmoji = (el) => {
  switch (el.id) {
    case '5':
    case '6':
    case '7':
    case '20':
      return (
        <div className="mr12 emoji">
          <Emoji symbol="💼" label="project" />
        </div>
      );
    default:
      return (
        <div className="mr12 emoji">
          <Emoji symbol="💼" label="project" />
        </div>
      );
  }
};

const getPatchEmoji = (el) => {
  switch (el.id) {
    case PATCH_VIEWS.allPatches:
    case PATCH_VIEWS.failedPatches:
    case PATCH_VIEWS.latestPatches:
    case PATCH_VIEWS.pendingApproval:
      return (
        <div className="fx actr mr12 emoji">
          <SVGIcon
            name="PatchLight"
            color={el.iconColor ?? '#307152'}
            size="sm"
          />
        </div>
      );
    default:
      return (
        <div className="fx actr mr12 emoji">
          <SVGIcon
            name="PatchLight"
            color={el.iconColor ?? '#307152'}
            size="sm"
          />
        </div>
      );
  }
};

const getAlertEmoji = (el) => {
  switch (el.id) {
    case ALERT_VIEWS.allAlerts:
      return (
        <div className="fx actr mr12 emoji">
          <SVGIcon name="AlertIcon" color={el.iconColor ?? 'red'} size="sm" />
        </div>
      );
    default:
      return (
        <div className="fx actr mr12 emoji">
          <SVGIcon name="AlertIcon" color={el.iconColor ?? 'red'} size="sm" />
        </div>
      );
  }
};

const getAssetEmoji = (el) => {
  switch (el.id) {
    default:
      return (
        <div className="fx actr mr12 emoji">
          <SVGIcon
            name="AssetGroup"
            color={el.iconColor ?? '#AE39B2'}
            size="sm"
          />
        </div>
      );
  }
};

const getEmoji = (el) => {
  switch (el?.module) {
    case 'TICKET':
      return getTicketEmoji(el);
    case 'TASK':
      return getTaskEmoji(el);
    case 'PATCH':
      return getPatchEmoji(el);
    case 'ALERT':
      return getAlertEmoji(el);
    case 'ASSET_VIEWS':
      return getAssetEmoji(el);
    case 'PROJECT':
      return getProjectEmoji(el);
    case 'MENTION':
      return (
        <div className="fx actr mr12 emoji">
          <Emoji symbol="🌟" label="my_mentions" />
        </div>
      );
    case 'REPORTS':
      return (
        <div className="fx actr mr12 emoji">
          <SVGIcon name="ChartLine" />
        </div>
      );
    case 'WIDGET':
      return (
        <div className="fx actr mr12 emoji">
          <SVGIcon name="ChartLine" color="#E66FEA" />
        </div>
      );

    default:
      return (
        <div className="fx actr mr12 emoji">
          <Emoji symbol="🎟️" label="default_ticket" />
        </div>
      );
  }
};

export { getEmoji };
